import { shape, oneOf } from 'prop-types';
import styled from 'styled-components';
import { DateTime } from 'luxon';
import DetailMap from '../DetailMap';
import { PROJECT_TYPES, MULTIMEDIA_TYPES } from '../../../config';
import { ReactComponent as ErrorSvg } from '../../../assets/icons/circle-exclamation-solid.svg'
import TagMenu from './tagMenu';

const ErrorIcon = styled(ErrorSvg)`
    width: 30px;
    height: auto;
    fill: ${({theme}) => theme.colors.bg_gray_dark};
    margin-bottom: 16px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 2rem;
  column-gap: 2rem;
  position: relative;

  @media screen and (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const InfoWrapper = styled(Grid)`
  grid-template-columns: 1fr;
  column-gap: 1rem;
`;

const MapWrapper = styled.div`
  position: relative;
  z-index: 0;
  min-height: 300px;
`;

const Table = styled.table`
  border-collapse: collapse;

  tr td {
    padding: 0.25rem 1rem;
    vertical-align: top;
    border-bottom: 1px solid ${({ theme }) => theme.colors.bg_gray};
  }

  tr td:first-child {
    font-weight: bold;
    padding-right: 1.5rem;
  }

  ul {
    list-style-type: square;
  }
`;

const MissingMapData = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: ${({theme}) => theme.colors.bg_gray_light};
`;

const ActionsWrapper = styled.div`
  background-color: ${({theme}) => theme.colors.bg_gray_light};
  padding: 1rem;
  margin: 1rem 0;
`;

const getTypeStr = type => {
  switch(type) {
    case 'single':
      return 'Photo';
    case 'panorama':
      return 'Panorama';
    case 'video':
      return 'Video';
    default:
      return '-';
  }
}

function BasicMultimediaInformation({data, type}) {
    return (
      <Grid>
        <InfoWrapper id="informationTable">
          <Table>
            <tbody>
              <tr>
                <td>Name</td>
                <td>{data.name}</td>
              </tr>
              <tr>
                <td>ID</td>
                <td>{data.id}</td>
              </tr>
              <tr>
                <td>Description</td>
                <td>{data.description}</td>
              </tr>
              <tr>
                <td>Type</td>
                <td>{getTypeStr(type)}</td>
              </tr>
              <tr>
                <td>Created</td>
                <td>{!data.created ? '-' : DateTime.fromISO(data.created).toLocaleString({dateStyle: 'long', timeStyle: 'medium', hour12: false})}</td>
              </tr>
              <tr>
                <td>Captured</td>
                <td>{!data.captured ? '-' : DateTime.fromISO(data.captured).toLocaleString({dateStyle: 'long', timeStyle: 'medium', hour12: false})}</td>
              </tr>
              <tr>
                <td>Drone</td>
                <td>{data.drone}</td>
              </tr>
              <tr>
                <td>Location</td>
                <td>{!data.geometry ? '-' : data.geometry.coordinates.join(', ')}</td>
              </tr>
            </tbody>
          </Table>
          {
            data.status === 5 && (
              <ActionsWrapper>
                <TagMenu id={data.id} tagId={data.tag} />
              </ActionsWrapper>
          )}
        </InfoWrapper>
        <MapWrapper>
          {
            data.geometry ? (
              <DetailMap mapData={[{geometry: data.geometry, type: "Feature", properties: {id: data.id, type: type, name: data.name}}]} />
            ) : (
              <MissingMapData>
                <ErrorIcon />
                <span>Missing map data</span>
              </MissingMapData>
            )
          }
        </MapWrapper>
      </Grid>
    );

}

BasicMultimediaInformation.propTypes = {
  data: shape({}).isRequired,
  type: oneOf(PROJECT_TYPES).isRequired,
}

export default BasicMultimediaInformation;